import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-event-keys',
  templateUrl: './event-keys.component.html',
  styleUrls: ['./event-keys.component.scss']
})
export class EventKeysComponent implements OnInit {

  @Input() year: string;

  constructor() { }

  ngOnInit(): void {
  }

}
